import { memo, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useApi } from "../../../../hooks/api.hook";
import SplitBuyPaymentFailed from "./section/splitBuyFailed/splitBuyFailed.section";
import { ComponentLoader } from "../../../../components/loaders";
import SplitBuyPaymentSuccess from "./section/splitBuySuccess/splitBuySuccess.section";
import SplitBuyPaymentPending from "./section/splitBuyPending/splitBuyPending.section";
import { useNavigate } from "react-router";
import { useCart } from "../../../../providers/cart.provider";
import { useAuth } from "../../../../providers/authentication.provider";

export const OrderCompletePage = memo(() => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [verifiedData, setVerifiedData] = useState(null);
  const navigate = useNavigate();
  const api = useApi();
  const { removeFromCart, removeGuestCartItems } = useCart();
  const { isGuestUser } = useAuth();

  useEffect(() => {
    const verifyTransaction = async () => {
      const reference =
        searchParams.get("trxref") || searchParams.get("reference");

      if (!reference) {
        setStatus("error");
        navigate(-1);
        return;
      }

      try {
        const { data: respData } = await api.get(
          `split-buy/verify-payment?reference=${encodeURIComponent(reference)}`,
          {
            headers: {
              "guest-user-key": isGuestUser
                ? process.env.REACT_APP_API_GUEST_USER_KEY
                : undefined,
            },
          }
        );

        const { data } = respData;
        const payment_status = data?.payment_status || "failed";

        if (payment_status === "success") {
          setVerifiedData(data);
          setStatus("success");
          sessionStorage.removeItem("pending_checkout");
          if (isGuestUser) {
            await clearGuestCartItems();
          }
        } else if (payment_status === "pending") {
          setStatus("pending");
        } else {
          setStatus("failed");
        }
      } catch (err) {
        setStatus("error");
      }
    };

    const clearGuestCartItems = async () => {
      try {
        const pendingCartItems = JSON.parse(
          sessionStorage.getItem("pending_payment_cart_items") || "[]"
        );
        if (!pendingCartItems.length) return;

        removeGuestCartItems(pendingCartItems);
        pendingCartItems.forEach((cartItemId) => removeFromCart(cartItemId));
        sessionStorage.removeItem("pending_payment_cart_items");
      } catch (error) {
        try {
          const pendingCartItems = JSON.parse(
            sessionStorage.getItem("pending_payment_cart_items") || "[]"
          );
          pendingCartItems.forEach((cartItemId) => removeFromCart(cartItemId));
          sessionStorage.removeItem("pending_payment_cart_items");
        }catch {}
      }
    };

    verifyTransaction();
  }, [
    searchParams,
    api,
    navigate,
    removeFromCart,
    removeGuestCartItems,
    isGuestUser,
  ]);

  if (status === "loading") return <ComponentLoader />;
  if (status === "success")
    return <SplitBuyPaymentSuccess verifiedData={verifiedData} />;
  if (status === "pending") return <SplitBuyPaymentPending />;
  return <SplitBuyPaymentFailed />;
});
